import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
import commonStore from '../stores/commonStore';
import authStore from '../stores/authStore';
import navigatorStore from '../stores/navigatorStore';
import axios from 'axios';
import searchResultspage from '../components/Home/profile/search/searchPage';
import searchResultspageArtworks from '../components/Home/profile/search/searchPageArtworks';
import searchResultspageArtists from '../components/Home/profile/search/searchPageArtists';
import userStore from '../stores/userStore';
// import authStore from '../stores/authStore';
import { API_ROOT, API_NO_ROOT } from '../env/index'
var qs = require('qs')

const superagent = superagentPromise(_superagent, global.Promise);


const encode = encodeURIComponent;

const handleErrors = (err, res) => {

  //console.log("[response in handle error]", res)
  if (res) {
    if (res.body) {
      if (res.body.data == "Artwork not found") {
        return;
      }
      if (!!res.body.detail) {
        // if (res.body.detail) {
        if (/invalid/i.test(res.body.detail) && res.unauthorized) {
          localStorage.setItem("dontOpenErrorModal", true)
          authStore.logout();
          navigatorStore.openSignInModal();
          return;
        }
        else {
          commonStore.removeLoader();
          // navigatorStore.openErrorModal("Something went wrong. Please try again.");
        }
        return;
        // }
      }
    }
    if (!res.body || res.body == {}) {
      commonStore.removeLoader();
      navigatorStore.openErrorModal("Something went wrong. Please try again.")
      return;
    }
    if (res.body.error == "True") {
      commonStore.removeLoader();
      if (/unsuccessful/i.test(res.body.message) || res.unauthorized) {
        navigatorStore.openSignInModal()
        return;
      }
     
      else navigatorStore.openErrorModal(res.body.message);
      return;
    }

  }

  if (err) {
    if (res) {
      commonStore.removeLoader();
      navigatorStore.openErrorModal(JSON.parse(res.text).message);
      return;
    }
    else {
      commonStore.removeLoader();
      navigatorStore.openErrorModal("Something went wrong. Please try again.");
      return;
    }
    // return;
  }
};
const handleErrorsNoMSG = (err, res) => {

  //console.log("[response in handle error]", res)
  if (res) {
    if (res.body) {
      if (res.body.detail) {
        if (res.body.detail) {
          commonStore.removeLoader();

          // navigatorStore.openErrorModal("Something went wrong. Please try again.");
          return;
        }
      }
    }
    if (!res.body || res.body == {}) {
      commonStore.removeLoader();
      // navigatorStore.openErrorModal("Something went wrong. Please try again.")
      return;
    }
    if (res.body.error == "True") {
      commonStore.removeLoader();
      // navigatorStore.openErrorModal(res.body.message);
      return;
    }

  }

  if (err) {
    if (res) {
      commonStore.removeLoader();
      navigatorStore.openErrorModal(JSON.parse(res.text).message);
      return;
    }
    else commonStore.removeLoader();
    navigatorStore.openErrorModal("Something went wrong. Please try again.");
    return;
    // return;
  }
};
const handleOnlyNetworkErrors = (err, res) => {

  if (res.body.detail) {
    if (res.body.detail) {
      commonStore.removeLoader();
      // navigatorStore.openErrorModal("Something went wrong. Please try again.");
      return;
    }
    return;
  }

  if (err) {
    if (res) {
      commonStore.removeLoader();
      // navigatorStore.openErrorModal(JSON.parse(res.text).message);
      return;
    }
    // navigatorStore.openErrorModal(err)
    return;
  }
  return;
};

const responseBody = res => res.body;

const tokenPlugin = req => {
  if (commonStore.token) {
    req.set('authorization', `Token ${commonStore.token}`);
  }
};
const authTokenConfig = () => {
  if (commonStore.token) {
    return { 'authorization': `Token ${commonStore.token}` };
  } else {
    throw "no token present"
  }
};

const requests = {
  get: (url, body, paginationQuery, filterSearchQuery, hideTheLoader) => {
    //console.log("look at this for one more hint", qs.stringify(filterSearchQuery), paginationQuery)
    if (!hideTheLoader) {
      commonStore.setLoader();
    }
    return superagent
      .get(`${API_ROOT}${url}`, body)
      .query(qs.stringify(paginationQuery))
      .query(filterSearchQuery)
      // .set('Authorization', `Token 9a5d74627c613bbce6a2af452d13462a9ccf3b9b`)
      .set('Authorization', `Token ${window.localStorage.getItem('userData')}`)
      .end(handleErrors)
      .then(responseBody)
      .then(
        function (rBody) {
          if (!hideTheLoader) {
            commonStore.removeLoader();
          }
          return rBody
        })
  },
  publicAPI: (url, body, paginationQuery, filterSearchQuery, hideTheLoader) => {
    //console.log("look at this for one more hint", qs.stringify(filterSearchQuery), paginationQuery)
    if (!hideTheLoader) {
      commonStore.setLoader();
    }
    return superagent
      .get(`${API_ROOT}${url}`, body)
      .query(qs.stringify(paginationQuery))
      .query(filterSearchQuery)
      // .set('Authorization', `Token 9a5d74627c613bbce6a2af452d13462a9ccf3b9b`)
      // .set('Authorization', `Token ${window.localStorage.getItem('userData')}`)
      .end(handleErrors)
      .then(responseBody)
      .then(
        function (rBody) {
          if (!hideTheLoader) {
            commonStore.removeLoader();
          }
          return rBody
        })
  },
  getNoMessage: (url, body, paginationQuery, filterSearchQuery, hideTheLoader) => {
   // console.log("look at this for one more hint", qs.stringify(filterSearchQuery), paginationQuery)
    if (!hideTheLoader) {
      commonStore.setLoader();
    }
    return superagent
      .get(`${API_ROOT}${url}`, body)
      .query(qs.stringify(paginationQuery))
      .query(filterSearchQuery)
      .set('Authorization', `Token ${window.localStorage.getItem('userData')}`)
      .end(handleErrorsNoMSG)
      .then(responseBody)
      .then(
        function (rBody) {
          if (!hideTheLoader) {
            commonStore.removeLoader();
          }
          return rBody
        })
  },
  rawGet: (url, body, paginationQuery, filterSearchQuery) => {
   // console.log("look at this for one more hint", qs.stringify(filterSearchQuery), paginationQuery)
    commonStore.setLoader();
    return superagent
      .get(`${API_ROOT}${url}`, body)
      .query(qs.stringify(paginationQuery))
      .query(filterSearchQuery)
      // .set('key', 'pyc4i1TjeauQM9sGXd23j7RXiDsb3AYv')
      .set('Authorization', `pyc4i1TjeauQM9sGXd23j7RXiDsb3AYv`)
      .end(handleErrors)
      .then(responseBody)
      .then(
        function (rBody) {
          commonStore.removeLoader();
          return rBody
        })
  },

  post: (url, body, hideTheLoader, hideTheMsg) => {
    /* post fir file upload */
   // console.log("chal na veta ", body instanceof FormData, body, !hideTheLoader)
    if (!hideTheLoader) {
      commonStore.setLoader();
    }
    return superagent
      // .post(`https://404832dc.ngrok.io/api/v1/products/artwork/new`)
      .post(`${API_ROOT}${url}`)
      // .set('Content-Type', `application/x-www-form-urlencoded`)
      .set('Authorization', (localStorage.hasOwnProperty("userData")) ? `Token ${window.localStorage.getItem('userData')}`: 'pyc4i1TjeauQM9sGXd23j7RXiDsb3AYv')
      .send((body instanceof FormData) ? body : qs.stringify(body))
      .end((hideTheMsg) ? handleErrorsNoMSG :handleErrors)
      .then(responseBody)
      .then(
        function (rBody) {
          if (!hideTheLoader) {
            commonStore.removeLoader();
          }
          return rBody
        })
  },
  postFileUpload: (url, body, progressLoader, forArtwork) => {
    /* post fir file upload */
   // console.log("{setProgressLoader}", progressLoader)
   // console.log("chal na veta ", body instanceof FormData, body)
    if (progressLoader) { commonStore.setProgressLoader(forArtwork) }
    else { commonStore.setLoader(); }
    return superagent
      // .post(`https://404832dc.ngrok.io/api/v1/products/artwork/new`)
      .post(`${API_ROOT}${url}`)
      // .set('Content-Type', `application/x-www-form-urlencoded`)
      .set('Authorization', `Token ${window.localStorage.getItem('userData')}`)
      .send(body)
      .end(handleErrors)
      .then(responseBody)
      .then(
        function (rBody) {
          commonStore.removeLoader();
          return rBody
        })
  },
  patchForEdit: (url, form, body, progressLoader,hideLoader) => {
    //console.log("{setProgressLoader}", progressLoader)
    if (progressLoader && !hideLoader) { commonStore.setProgressLoader() }
    else { if(!!hideLoader)  commonStore.setLoader(); }
    return superagent
      .patch(`${API_ROOT}${url}`)
      .send(form || qs.stringify(body))
      .set('Authorization', `Token ${window.localStorage.getItem('userData')}`)

      .end(handleErrors)
      .then(responseBody)
      .then(
        function (rBody) {
          commonStore.removeLoader();
          return rBody
        })
  },
  patchForEditOnBlurr: (url, body) => {
    // commonStore.setLoader();
    return superagent
      .patch(`${API_ROOT}${url}`)
      .send(body)
      .set('Authorization', `Token ${window.localStorage.getItem('userData')}`)
      .end(handleOnlyNetworkErrors)
      .then(responseBody)
      .then(
        function (rBody) {
          // commonStore.removeLoader();
          return rBody
        })
  },
  postForEditOnBlurr: (url, body) => {
    // commonStore.setLoader();
    return superagent
      .post(`${API_ROOT}${url}`)
      .send(body)
      .set('Authorization', `Token ${window.localStorage.getItem('userData')}`)
      .end(handleErrors)
      .then(responseBody)
      .then(
        function (rBody) {
          // commonStore.removeLoader();
          return rBody
        })
  },
  raw: (url, body, method) => {
    commonStore.setLoader();
    return superagent
      .post(`${API_ROOT}${url}`, body)
      // .then(setTimeout(function(){ console.log("Hello"); }, 3000))
      // .end(commonStore.removeLoader())
      .end(handleErrors)
      .then(responseBody)
      .then(
        function (rBody) {
          commonStore.removeLoader();
          return rBody
        })
  },
  rawNoRoot: (url, body, method) => {
    commonStore.setLoader();
    return superagent
      .post(`${API_NO_ROOT}${url}`, body)
      // .then(setTimeout(function(){ console.log("Hello"); }, 3000))
      // .end(commonStore.removeLoader())
      .end(handleErrors)
      .then(responseBody)
      .then(
        function (rBody) {
          commonStore.removeLoader();
          return rBody
        })
  },
  NoRoot: (url, body, method) => {
    commonStore.setLoader();
    return superagent
      .post(`${API_NO_ROOT}${url}`, body)
      // .then(setTimeout(function(){ console.log("Hello"); }, 3000))
      .set('Authorization', `Token ${window.localStorage.getItem('userData')}`)
      .end(handleErrors)
      .then(responseBody)
      .then(
        function (rBody) {
          commonStore.removeLoader();
          return rBody
        })
  },
  NoRootAuth: (url, body, method) => {
    commonStore.setLoader();
    return superagent
      .post(`${API_NO_ROOT}${url}`, body)
      // .then(setTimeout(function(){ console.log("Hello"); }, 3000))
      // .set('Authorization', `Token ${window.localStorage.getItem('userData')}`)
      .end(handleErrors)
      .then(responseBody)
      .then(
        function (rBody) {
          commonStore.removeLoader();
          return rBody
        })
  },
};

const Auth = {
  // current: (email, password, login_type) =>
  //   requests.post('/login', { email: email, password: password, login_type: login_type }),
  login: (form) =>
    requests.raw('/users/login', form, "post"),
  register: (email, password) =>
    requests.raw('/users/register', qs.stringify(email, password), "post"),
  socialLogin: (body) =>
    requests.raw('/users/social/register', body),
  forgotPassword: (body) =>
    requests.raw('/users/password/reset/', body),
  resetPassword: (body, auth_key) =>
    requests.rawNoRoot(`/emails/auth/reset/${auth_key}`, body),
  changePasswordSecurity: (body, auth_key) =>
    requests.rawNoRoot(`/api/v1/users/reset/password/email/${auth_key}`, body),
  updatePW: (body) =>
    requests.NoRoot(`/api/v1/users/password/change/`, body),
  sendEmailVerification: (id , ) =>
    requests.NoRoot(`/emails/confirmation/${id}`),
  verifyEmail: (key) =>
    requests.NoRootAuth(`/emails/auth/confirm/${key}`)
  // googleLogin: (goog_id) =>
  //   requests.raw('/users/social/register', { goog_id }),


};
const Users = {
  // current: (email, password, login_type) =>
  //   requests.post('/login', { email: email, password: password, login_type: login_type }),
  currentUser: (profile_id) =>
    requests.get(`/profiles/details/${profile_id}`, null, null, null, true),
  editUser: (profile_id, form, body, progressLoader,hideLoader) =>
    requests.patchForEdit(`/profiles/details/${profile_id}`, form, body, progressLoader,hideLoader),
  editUserOnBlurr: (profile_id, form, body) =>
    requests.patchForEditOnBlurr(`/profiles/details/${profile_id}`, form, body),
  validateUserName: (profile_id, username) =>
    requests.postForEditOnBlurr(`/profiles/check/username`, username),



};

const Artworks = {
  getAll: (filterSearchQuery, paginationQuery, hideTheLoader) =>
    // console.log("[look at this for hint]",filterSearchQuery, paginationQuery)

    requests[localStorage.hasOwnProperty("userData") ? "get" : "rawGet"](`/products/artworks/`, null, paginationQuery, filterSearchQuery, hideTheLoader),
  getArtworksByCategory: (filterSearchQuery, paginationQuery) =>
    requests.rawGet(`/products/artworks/public/pick/`, paginationQuery, filterSearchQuery),
  getArtworkDetailsPrivate: (id) =>
    requests.get(`/products/artwork/details/${id}`),
  getArtworkDetailsPublic: (id) =>
    requests.rawGet(`/products/artwork/public/user/${id}`),
  getArtworkDetailsPublicAuth: (id, body, hideTheLoader) =>
    requests.get(`/products/artwork/user/${id}`, body, null, null, hideTheLoader),
  getArtworkDetailsPublicAuthNoMessage: (id, body, hideTheLoader) =>
    requests.rawGet(`/products/artwork/url/${id}`, body, null, null, hideTheLoader),
  getArtworkDetailsPublicAuthNoMessagePrivate: (id, body, hideTheLoader) =>
    requests.get(`/products/artwork/url/${id}`, body, null, null, hideTheLoader),
  getArtworkCollectionPublicAuth: (id, hide, paginationQuery) =>
    requests.get(`/products/artworks/liked/${id}`, null, paginationQuery, null, hide),
  createNewArtwork: (body) =>
    requests.postFileUpload(`/products/artwork/new`, body, true,true),
  updateArtwork: (id, body) =>
    requests.patchForEdit(`/products/artwork/details/${id}`, null, body),
  addArtworkImage: (id, form, body) =>
    requests.patchForEdit(`/products/artwork/details/${id}`, form, body, true),
  reportArtwork: (id, body) =>
    requests.post(`/products/report/artwork/${id}`, body),
  deleteArtwork: (id) =>
    requests.patchForEdit(`/products/artwork/delete/${id}`)

}
const CategoryArtworks = {
  getBrowseAllArtworks: (filterSearchQuery, paginationQuery, hideTheLoader) =>
      requests.getNoMessage(`/products/artworks`, null, paginationQuery, filterSearchQuery, hideTheLoader, true),

  getBrowseAllArtworksPublic: (filterSearchQuery, paginationQuery) =>
      // console.log("[look at this for hint]",filterSearchQuery, paginationQuery)
      requests.rawGet(`/products/artworks`, null, paginationQuery, filterSearchQuery),

  getArtworksByCategory: (filterSearchQuery, paginationQuery, hideTheLoader) =>
     //console.log("[look at this for hint]",filterSearchQuery, paginationQuery),
      requests.getNoMessage(`/products/artworks/tag`, null, paginationQuery, filterSearchQuery, hideTheLoader, true),
  getArtworksByCategoryPublic: (filterSearchQuery, paginationQuery) =>
    // console.log("[look at this for hint]",filterSearchQuery, paginationQuery)
    requests.rawGet(`/products/artworks/public/pick/`, null, paginationQuery, filterSearchQuery),

  getRecentArtworks: (paginationQuery) =>
    // console.log("[look at this for hint]",filterSearchQuery, paginationQuery)
      requests.getNoMessage(`/products/artworks/tag`, null, paginationQuery),
  getRecentArtworksPublic: (paginationQuery) =>
    // console.log("[look at this for hint]",filterSearchQuery, paginationQuery)
    requests.rawGet(`/products/artworks/public/pick`, null, paginationQuery),


}
const Artists = {

  getAllArtistsCategory: (query, pagination, hideTheLoader) =>
    requests.get(`/profiles/users/pick/`, null, query, pagination, hideTheLoader),
  getArtistsCategoryPublic: (query, pagination, hideTheLoader) =>
    requests.rawGet(`/profiles/users/public/pick/`, null, query, pagination, hideTheLoader),
  getAllArtists: (query, pagination, hideTheLoader) =>
    requests[localStorage.hasOwnProperty("userData") ? "get" : "rawGet"]('/profiles/users/', null, query, pagination, hideTheLoader),
  getAllArtistsCountry: (query, pagination, hideTheLoader) =>
    requests.get('/profiles/users/country/', null, query, pagination, hideTheLoader),
  getAllArtistsMedium: (query, pagination, hideTheLoader) =>
    requests.get('/profiles/users/medium', null, query, pagination, hideTheLoader),
  getArtistDetailsPublic: (id, hideTheLoader, paginationQuery) =>
    requests.publicAPI(`/profiles/user/url/${id}`, null, paginationQuery, null, hideTheLoader),
  getArtistDetailsPrivate: (id, hideTheLoader, paginationQuery) =>
    requests.get(`/profiles/user/url/${id}`, null, paginationQuery, null, hideTheLoader),
  // requests.rawGet(`/profiles/user/url/${id}`, null, null, null, hideTheLoader),
  // getArtistDetailsPublic: (id) =>
  //   requests.rawGet(`/profiles/user/${id}`),
  getArtistArtworksPrivate: (id) =>
    requests.get(`/profiles/user/${id}`),
}


const FollowAndUnfollow = {
  followTheUser: (id) =>
    requests.post(`/profiles/follow/${id}`, null, true),
  unFollowTheUser: (id) =>
    requests.post(`/profiles/unfollow/${id}`, null, true),
  followersList: (id,paginationQuery) =>
    requests.get(`/profiles/followers/${id}`, null, paginationQuery, null, true),
  followingList: (id,paginationQuery) =>
    requests.get(`/profiles/following/${id}`, null, paginationQuery, null, true),

}
const LikeAndUnlike = {
  likeTheArtwork: (id) =>
    requests.post(`/products/artwork/like/${id}`, null, true,true),

  unLikeTheArtwork: (id) =>
    requests.post(`/products/artwork/unlike/${id}`, null, true,true),
}
const Orders = {
  artworkBuyRequest: (id, body) =>
    requests.post(`/request/artwork/${id}`, body),

  // unLikeTheArtwork: (id) =>
  //   requests.post(`/products/artwork/unlike/${id}`),
}


const generalData = {
  listOfCurrencies: () =>
    requests.get('/products/currencies'),
  listOfMediums: () =>
    requests.get('/products/mediums'),
  listOfBases: () =>
    requests.get('/products/bases'),
  blogApi : ()=>
  requests.rawGet('/blog/feed'),
  AOTM : ()=>
  requests.rawGet('/profiles/aotm'),
  commissioningRequest : (form)=>
  requests.post('/profiles/sales/request',form,true),
  subscribeRequest:(form)=>
      requests.post('/profiles/subscribe/newsletter',form,true),
  artworkSlug:(id)=>
      requests.rawGet(`/products/artwork/shareurl/${id}`,null,true),
  artistSlug:(id)=>
      requests.rawGet(`/profiles/user/shareurl/${id}`,null,true),
}





export default {

  Auth,
  Users,
  API_ROOT,
  Artworks,
  Artists,
  FollowAndUnfollow,
  LikeAndUnlike,
  generalData,
  Orders,
  CategoryArtworks,
};



// WEBPACK FOOTER //
// ./src/api/agent.js